import { render, staticRenderFns } from "./MaterDrawerSelect.vue?vue&type=template&id=2f6f662f"
import script from "./MaterDrawerSelect.vue?vue&type=script&lang=js"
export * from "./MaterDrawerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports